// extracted by mini-css-extract-plugin
module.exports = {"root":"ContentBlocks_root__EVmuJ","block":"ContentBlocks_block__zQqCR"};